import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home/index.vue";

import Meta from "vue-meta";
import auth from "@/router/auth";

Vue.use(VueRouter);

Vue.use(Meta, {
  keyName: "metaInfo", // the component option name that vue-meta looks for meta info on.
  attribute: "data-vue-meta", // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: "data-vue-meta-server-rendered", // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: "vmid", // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

const routes = [
  {
    path: "/",
    name: "home-index",
    component: Home,
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/login",
    name: "account-login",
    component: () => import("@/views/account/Login.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/register",
    name: "account-register",
    component: () => import("@/views/account/Register.vue"),
    beforeEnter: auth.requireAuthV2,
  },

  // Profile
  /*{
    path: "/profile",
    name: "account-profile",
    component: () => import("@/views/account/Profile.vue"),
    beforeEnter: auth.requireAuth,
  },*/
  /*{
    path: "/print-bill/:bag_id",
    name: "print-bill",
    component: () => import("@/views/print/Index.vue"),
    beforeEnter: auth.requireAuthV2,
  },*/

  // Module Danh sách nhân viên
  {
    path: "/setting/list-user",
    name: "setting-lists-user",
    component: () => import("@/views/user/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/list-user-vpo",
    name: "setting-lists-user-vpo",
    component: () => import("@/views/user/Vpo.vue"),
    beforeEnter: auth.requireAuth,
  },
  // Module Danh sách công ty
  {
    path: "/setting/list-company",
    name: "setting-lists-company",
    component: () => import("@/views/company/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  // pack
  {
    path: "/service/list-of-goods",
    name: "list-of-goods",
    component: () => import("@/views/pack/list.vue"),
    beforeEnter: auth.requireAuth,
  },
  // báo giá
  {
    path: "/service/list-quote",
    name: "list-quote",
    component: () => import("@/views/quote/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/service/import-excel-ai",
    name: "import-excel-ai",
    component: () => import("@/views/quote/ImportExcelAI.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/service/history-quote",
    name: "history-quote",
    component: () => import("@/views/quote/history.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/service/approval-quote",
    name: "manager-approval-quote",
    component: () => import("@/views/manager-approval-quote/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  // hàng chờ báo giá
  {
    path: "/service/waiting-for-quote",
    name: "waiting-for-quote",
    component: () => import("@/views/waiting-for-quote/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/service/waiting-for-xnk-approval",
    name: "waiting-for-xnk-approval",
    component: () => import("@/views/waiting-for-xnk-approval/Index.vue"),
    beforeEnter: auth.requireAuth,
  },


  // Module phân quyền
  {
    path: "/setting/account/roles",
    name: "account-roles",
    component: () => import("@/views/roles/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/quote-update/:quote_id",
    name: "quote-update",
    component: () => import("@/views/quote/Update.vue"),
    beforeEnter: auth.requireAuth,
  },
  // quản lý cửa khẩu
  {
    path: "/setting/border-gate",
    name: "setting-border-gate",
    component: () => import("@/views/border-gate/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  // ds công ty xnk
  {
    path: "/setting/company-xnk",
    name: "setting-company-xnk",
    component: () => import("@/views/company-xnk/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  // Hàng chờ xác nhận
  {
    path: "/customs/goods-awaiting-confirmation",
    name: "goods-awaiting-confirmation",
    component: () => import("@/views/goods-awaiting-confirmation/Index.vue"),
    beforeEnter: auth.requireAnyPermission([
      "awaiting-confirmation.view-all",
      "awaiting-confirmation.view-all-agency",
    ]),
  },
  // Hàng hóa chờ thông quan
  {
    path: "/customs/goods-awaiting-clearance",
    name: "goods-awaiting-clearance",
    component: () => import("@/views/good-awaiting/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/declaration",
    redirect: "/accounting/",
  },
  {
    path: "/accounting/",
    name: "declaration",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/transport-partners",
    name: "accountant-transport-partners",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/expense-items",
    name: "accountant-expense-items",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/accounting/shipments",
    name: "accountant-shipments",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/accounting/cash-balance",
    name: "accountant-cash-balance",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/accounting/pay",
    name: "accountant-pay",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/accounting/income-expenditure",
    name: "accountant-income-expenditure",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/accounting/partner-debt",
    name: "accountant-partner-debt",
    component: () => import("@/views/accountant/Index.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/customers",
    name: "customer",
    component: () => import("@/views/customer/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/customs/goods-cleared-custom",
    name: "goods-cleared-custom",
    component: () => import("@/views/goods-cleared-custom/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  // Tỉ lệ nhận đơn
  {
    path: "/setting/acceptance-rate",
    name: "setting-acceptance-rate",
    component: () => import("@/views/acceptance-rate/List.vue"),
    beforeEnter: auth.requireAuth,
  },
  // báo cáo hiệu suất duyệt đơn
  {
    path: "/report/single-browsing-performance",
    name: "report-single-browsing-performance",
    component: () => import("@/views/report/single-browsing-performance/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/report/vipo-approval-performance",
    name: "report-vipo-approval-performance",
    component: () => import("@/views/report/vipo-approval-performance/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  // Chia đơn của KH
  {
    path: "/setting/assign-quote-staff",
    name: "setting-assign-quote-staff",
    component: () => import("@/views/assign-quote-staff/List.vue"),
    beforeEnter: auth.requireAuth,
  },

  {
    path: "/report/revenue",
    name: "report-revenue",
    component: () => import("@/views/report/revenue/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/report/report-excel-ai",
    name: "report-excel-ai",
    component: () => import("@/views/report/report-excel-ai/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/report/report-approval-quote-today",
    name: "report-approval-quote-today",
    component: () => import("@/views/report/report-approval-quote-today/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/chat-list",
    name: "chat-list",
    component: () => import("@/views/chat/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/service-price-list",
    name: "setting-service-price-list",
    component: () => import("@/views/service-price/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
  // iframe
  {
      path: "/form-quote",
    name: "form-quote",
    component: () => import("@/views/iframe-quote/Index.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/form-price",
    name: "form-price",
    component: () => import("@/views/iframe-quote/Price.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  {
    path: "/accounting/calculation-declaration",
    name: "accounting-calculation-declaration",
    component: () => import("@/views/accountant/calculationDeclaration.vue"),
    beforeEnter: auth.requireAuthV2,
  },
  // Trang test check-missing item-name
  {
    path: "/check-miss-test",
    name: "check-miss-test",
    component: () => import("@/views/quote/CheckMissTest.vue"),
    beforeEnter: auth.requireAuth,
  },
  // Trang admin fix lại attributes cho mô tả đã check (item_names / item_name_ais)
  {
    path: "/fix-check-miss-91ffeb4c5929",
    name: "fix-check-miss",
    component: () => import("@/views/quote/FixCheckMiss.vue"),
    beforeEnter: auth.requireAuth,
  },
  {
    path: "/setting/company-import-hs-codes",
    name: "setting-company-import-hs-codes",
    component: () => import("@/views/company-import-hs-code/Index.vue"),
    beforeEnter: auth.requireAuth,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
